// hooks/useSearch.js
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
// import { useLazySearchPropertiesQuery } from "../features/search/searchApiSlice";
import {
  setSearchQuery,
  setFilters,
  setFilterValue,
  setFiltersOpen,
  updateNumberFilter,
  toggleAmenity,
  clearAllFilters,
  // setSearchResults,
  // setLoading,
  // setError,
  // addToSearchHistory,
  addToRecentSearches,
  // selectAllSearchParams,
  selectFiltersOpen,
  selectSearchQuery,
  selectFilters,
  // selectSearchResults,
  // selectIsLoading,
  // selectSearchError,
  selectRecentSearches,
} from "../features/search/searchSlice";

export const useSearch = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Select state
  const searchQuery = useSelector(selectSearchQuery);
  const filters = useSelector(selectFilters);
  const filtersOpen = useSelector(selectFiltersOpen);
  // const searchResults = useSelector(selectSearchResults);
  // const isLoading = useSelector(selectIsLoading);
  // const error = useSelector(selectSearchError);
  // const allSearchParams = useSelector(selectAllSearchParams);
  const recentSearches = useSelector(selectRecentSearches); // Add this selector

  // API hooks
  // const [triggerSearch] = useLazySearchPropertiesQuery();

  // // Search handler
  // const handleSearch = async (customParams = null) => {
  //   const params = customParams || allSearchParams;

  //   dispatch(setLoading(true));
  //   dispatch(setError(null));

  //   try {
  //     let searchParams = { ...params };

  //     // If custom params include suggestion data, structure the query accordingly
  //     if (params.suggestionId) {
  //       searchParams = {
  //         suggestionId: params.suggestionId,
  //         ...filters, // Include any active filters
  //       };
  //     } else if (params.title && params.location) {
  //       searchParams = {
  //         title: params.title,
  //         location: params.location,
  //         ...filters,
  //       };
  //     } else if (typeof params.query === "object") {
  //       // Handle if query is a suggestion object
  //       searchParams = {
  //         title: params.query.title,
  //         location: params.query.location,
  //         ...filters,
  //       };
  //     }

  //     // Remove undefined values
  //     Object.keys(searchParams).forEach((key) => {
  //       if (searchParams[key] === undefined || searchParams[key] === "") {
  //         delete searchParams[key];
  //       }
  //     });

  //     const result = await triggerSearch(searchParams);

  //     if (result.data) {
  //       dispatch(setSearchResults(result.data));

  //       // Add to history
  //       dispatch(
  //         addToSearchHistory({
  //           query: searchParams.query || searchParams.title || "",
  //           filters: { ...filters },
  //           resultCount: result.data.results?.length || 0,
  //         })
  //       );

  //       // Add to recent searches
  //       if (searchParams.query || searchParams.title) {
  //         dispatch(
  //           addToRecentSearches({
  //             query: searchParams.query || searchParams.title,
  //             timestamp: new Date().toISOString(),
  //           })
  //         );
  //       }
  //     } else if (result.error) {
  //       dispatch(setError(result.error.data?.message || "Search failed"));
  //     }
  //   } catch (err) {
  //     dispatch(setError(err.message || "Search failed"));
  //   } finally {
  //     dispatch(setLoading(false));
  //   }
  // };

  const handleClearAllAndNavigate = () => {
    // 1. Clear all filters in Redux
    dispatch(clearAllFilters());

    // 2. Clear search query in Redux
    dispatch(setSearchQuery(""));

    // 3. Close filters if open
    if (filtersOpen) {
      dispatch(setFiltersOpen(false));
    }

    // 4. Navigate to clean URL
    navigate("/search");
  };

  const handleSearch = (e) => {
    if (e) e.preventDefault();

    // 1. Add to recent searches (Optional, but good UX)
    if (searchQuery.trim()) {
      dispatch(addToRecentSearches(searchQuery));
    }

    // 2. Construct Query Params from State
    const params = new URLSearchParams();

    // Add Text Query
    if (searchQuery) params.set("q", searchQuery);

    // Add Filters to URL (Serialization)
    if (filters.minPrice > 0) params.set("minPrice", filters.minPrice);
    if (filters.maxPrice < 1000000) params.set("maxPrice", filters.maxPrice); // Assuming max default is high
    // if (filters.bedrooms > 0) params.set("bedrooms", filters.bedrooms);
    // if (filters.bathrooms > 0) params.set("bathrooms", filters.bathrooms);
    if (filters.gender) params.set("gender", filters.gender);
    if (filters.tenantType) params.set("tenantType", filters.tenantType);
    if (filters.sharingType) params.set("sharingType", filters.sharingType);
    if (filters.bathroomType) params.set("bathroomType", filters.bathroomType);
    // if (filters.propertyType) params.set("propertyType", filters.propertyType);

    // Add Array Filters (Amenities)
    if (filters.amenities && filters.amenities.length > 0) {
      // e.g., ?amenities=Wifi,Gym
      params.set("amenities", filters.amenities.join(","));
    }

    // 3. NAVIGATE (This triggers the route change)
    // .toString() turns the object into "q=dubai&bedrooms=2"
    // navigate(`/search?${params.toString()}`);

    // Navigate to search page
    const queryString = params.toString();
    navigate(`/search${queryString ? `?${queryString}` : ""}`);

    // 4. Close filters drawer on mobile if open
    if (filtersOpen) dispatch(setFiltersOpen(false));
  };

  const handleFilterChange = (field, value) => {
    dispatch(setFilterValue({ field, value }));
  };

  // Input change handler
  const handleInputChange = (value) => {
    dispatch(setSearchQuery(value));
  };

  // Filter handlers
  // const handlePriceChange = (min, max) => {
  //   dispatch(setFilters({ minPrice: min, maxPrice: max }));
  // };
  const handlePriceChange = (event, newValue) => {
    dispatch(
      setFilters({
        ...filters,
        minPrice: newValue[0],
        maxPrice: newValue[1],
      })
    );
  };

  const handleNumberChange = (field, delta) => {
    dispatch(updateNumberFilter({ field, delta }));
  };
  // const handleNumberChange = (name, operation) => {
  //   dispatch(updateNumberFilter({ name, operation }));
  // };

  const handleAmenityToggle = (amenity) => {
    dispatch(toggleAmenity(amenity));
  };

  // const handlePropertyTypeChange = (type) => {
  //   dispatch(setFilters({ propertyType: type }));
  // };
  const handlePropertyTypeChange = (type) => {
    dispatch(
      setFilters({
        ...filters,
        propertyType: filters.propertyType === type ? "" : type,
      })
    );
  };

  const handleClearAll = () => {
    dispatch(clearAllFilters());
    // handleClearAllAndNavigate();
    // Optional: If you want "Clear" to also reset the URL immediately:
    // navigate('/search');
  };

  const toggleFilters = () => {
    dispatch(setFiltersOpen(!filtersOpen));
  };
  // const toggleFilters = (isOpen) => {
  //   dispatch(setFiltersOpen(isOpen));
  // };

  const closeFilters = () => {
    dispatch(setFiltersOpen(false));
  };

  // Quick search (for recent searches)
  const handleQuickSearch = (query) => {
    dispatch(setSearchQuery(query));
    // Trigger search immediately
    const e = { preventDefault: () => {} };
    handleSearch(e);
    // handleSearch({ ...allSearchParams, query });
  };

  // // Clear recent searches
  // const clearRecentSearches = () => {
  //   // You'll need to add this action to your searchSlice
  //   // dispatch(clearRecentSearchesAction());
  // };

  // // Remove a specific recent search
  // const removeRecentSearch = (index) => {
  //   // You'll need to add this action to your searchSlice
  //   // dispatch(removeRecentSearchAction(index));
  // };

  // CALCULATE ACTIVE FILTERS
  const activeFilterCount = React.useMemo(() => {
    let count = 0;

    // Check Price (assuming defaults are 1000 and 10000)
    // if (filters.minPrice !== 1000) count++;
    // if (filters.maxPrice !== 10000) count++;
    if (filters.minPrice > 1000) count++;
    if (filters.maxPrice < 10000) count++;

    // Check Rooms
    // if (filters.bedrooms > 0) count++;
    // if (filters.bathrooms > 0) count++;

    // Check Type
    if (filters.gender) count++;
    if (filters.tenantType) count++;
    if (filters.sharingType) count++;
    if (filters.bathroomType) count++;
    // if (filters.propertyType !== "") count++;

    // Check Amenities (Count each selected amenity as 1, OR count the whole list as 1)
    // Option A: Count every amenity individually (Recommended for "2 filters applied")
    count += filters.amenities.length;

    return count;
  }, [filters]);

  return {
    // State
    searchQuery,
    filters,
    filtersOpen,
    // searchResults,
    recentSearches, // Add this to return
    // loading: isLoading,
    // error,
    // allSearchParams,
    activeFilterCount,

    // Handlers
    handleSearch,
    handleFilterChange,
    handleInputChange,
    handlePriceChange,
    handleNumberChange,
    handleAmenityToggle,
    handlePropertyTypeChange,
    handleClearAll,
    toggleFilters,
    handleQuickSearch,
    closeFilters,
    handleClearAllAndNavigate,
    // clearRecentSearches,
    // removeRecentSearch,
  };
};
